import 'core-js/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import { createBrowserHistory } from 'history'
import './index.css'
import 'react-quill/dist/quill.snow.css'
import 'react-select/dist/react-select.css'
import App from './App'
import configureStore from './modules/store'

const initialState = {}

const history = createBrowserHistory()

const { store, persistor } = configureStore(initialState, history)

const rootEl = document.getElementById('root')

ReactDOM.render(<App store={store} history={history} persistor={persistor} />, rootEl)

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default
    ReactDOM.render(
      <NextApp store={store} history={history} persistor={persistor} />,
      rootEl
    )
  })
}

export { store }
